import API from "../../../services/API";
import Formatter from "../../../services/Formatter";

export const fetchYEPPH = (event_key) => {
  return async (dispatch) => {
    return API.call({
      method: "get",
      url: "/event_registration/" + event_key,
    })
      .then((result) => {
        if (result.status === 200) {
          const content = result?.data?.content;
          dispatch({
            'type': 'FETCHED_YEP_PH',
            'content': content
          })
        }
      })
      .catch((e) => {
        dispatch(Formatter.alert_error(e));
      });
  }
}

export const fetchYEPPHTicket = (ticket_code) => {
  return async (dispatch) => {
    try {
      const result = await API.call({
        method: "get",
        url: "/event_checkin/" + ticket_code,
      });

      // Handle HTTP errors if API.call resolves them.
      if (result?.status === 403) {
        dispatch({
          type: "FETCHED_YEP_PH_TICKET",
          ticket: null,
          loading: false,
          status: "not_authorized",
          source: "try 403"
        });
        return;
      }

      const ticket = result?.data?.content;

      dispatch({
        type: "FETCHED_YEP_PH_TICKET",
        ticket: ticket || null,
        loading: false,
        status: !ticket
          ? "invalid"
          : ticket.checked_in_at
            ? "already_used"
            : "ready",
        source: "try"
      });
    } catch (e) {
      const status = e?.response?.status ?? e?.status ?? null;
      dispatch({
        type: "FETCHED_YEP_PH_TICKET",
        ticket: null,
        loading: false,
        status:
        status === 403
          ? "not_authorized"
          : status === 404
            ? "invalid"
            : status === 409
              ? "already_used"
              : status === 499
                ? null
                : status === null
                  ? "error"
                  : "error",
        source: "catch_" + status
      });
    }
  };
};

export const checkInYEPPHTicket = (ticket_code) => {
  return async (dispatch) => {
    try {
      const result = await API.call({
        method: "post",
        url: "/event_checkin/" + ticket_code,
      });

      const ticket = result?.data?.content;

      dispatch({
        type: "FETCHED_YEP_PH_TICKET",
        ticket: ticket || null,
        loading: false,
        status: !ticket
          ? "invalid"
          : ticket.checked_in_at
            ? "checked_in"
            : "ready",
      });

      return ticket;
    } catch (e) {
      const status = e?.response?.status ?? e?.status ?? null;
      const data = e?.response?.data ?? e?.data;

      let ticket = null;
      let ticketStatus = "error";

      if (status === 403) {
        ticketStatus = "not_authorized";
      } else if (status === 404) {
        ticketStatus = "invalid";
      } else if (status === 409) {
        ticketStatus = "already_used";
        ticket =
          data?.error?.content ??
          data?.content ??
          null;
      } else if (status === 499) {
        ticketStatus = null;
      } else if (status === null) {
        ticketStatus = "error";
      }

      dispatch({
        type: "FETCHED_YEP_PH_TICKET",
        ticket,
        loading: false,
        status: ticketStatus,
      });

      return null;
    }
  };
};

export const fetchEventRegistrationSummary = (eventKey) => {
  return async (dispatch) => {
    dispatch({
      type: "FETCHING_EVENT_REGISTRATION_SUMMARY",
    });

    const base = "/event_registration/" + eventKey;

    try {
      const [summaryResult, rowsResult] = await Promise.all([
        API.call({
          method: "get",
          url: base + "/summary",
        }),
        API.call({
          method: "get",
          url: base + "/rows",
        }),
      ]);

      const summary = summaryResult?.data?.content || null;
      const rows = rowsResult?.data?.content || [];

      dispatch({
        type: "FETCHED_EVENT_REGISTRATION_SUMMARY",
        summary,
        rows,
        status: summary ? "ready" : "error",
      });

      return { summary, rows };
    } catch (e) {
      const status = e?.response?.status ?? e?.status ?? null;
      const data = e?.response?.data ?? e?.data;

      console.log("[REGISTRATION SUMMARY] Error:", status, data);

      let registrationStatus = "error";

      if (status === 403) {
        registrationStatus = "not_authorized";
      } else if (status === 404) {
        registrationStatus = "invalid";
      } else if (status === 409) {
        registrationStatus = "already_used";
      } else if (status === 499 || status === null) {
        registrationStatus = null;
      }

      dispatch({
        type: "FETCHED_EVENT_REGISTRATION_SUMMARY",
        summary: null,
        rows: [],
        status: registrationStatus,
      });

      return null;
    }
  };
};